import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncateTextLength',
    standalone: false
})
export class TruncateTextLengthPipe implements PipeTransform {
  transform(text: string, length: number): string {
    if (text && length) {
      if (text.length > length) {
        return text.substring(0, length) + '...';
      } else {
        return text;
      }
    }
  }
}
